import { MouseEvent } from 'react'
import { AtButton, IconRef } from '../../atoms'
import { AtButtonBehaviors, AtButtonDimensions, AtButtonTypes } from '../../types'
import { cn } from '../../utils'

export interface MlCtaBarProps {
  primaryLabel?: string
  primaryIconRef?: IconRef
  primaryIcon?: string
  primaryDisabled?: boolean
  primaryTarget?: '_blank' | '_self'
  primaryActionValue?: string
  secondaryLabel?: string
  secondaryIconRef?: IconRef
  secondaryIcon?: string
  secondaryDisabled?: boolean
  secondaryTarget?: '_blank' | '_self'
  secondaryActionValue?: string
  onSecondaryClick?: () => void
  onTrackPrimaryClick?: (event?: MouseEvent<HTMLButtonElement>) => void
  onTrackSecondaryClick?: (event?: MouseEvent<HTMLButtonElement>) => void
  secondaryClassName?: string
  primaryClassName?: string
  className?: string
  parentName?: string
}

const buttonClasses = '!h-auto py-2.5 slg:py-4 text-14 slg:text-16'

export const MlCtaBar = ({
  onSecondaryClick,
  onTrackPrimaryClick,
  onTrackSecondaryClick,
  primaryLabel,
  primaryIconRef,
  secondaryLabel,
  primaryDisabled,
  secondaryDisabled,
  primaryTarget,
  secondaryTarget,
  primaryActionValue,
  secondaryActionValue,
  primaryIcon,
  secondaryClassName = '',
  primaryClassName = '',
  className = '',
  parentName = 'MlCtaBar',
}: MlCtaBarProps) => (
  <div
    className={`flex flex-col gap-2 items-center border-t-1 border-neutrals-300 lg:border-t-transparent ${className}`}
  >
    {primaryLabel && (
      <AtButton
        typeButton={primaryActionValue ? AtButtonBehaviors.BUTTON : AtButtonBehaviors.SUBMIT}
        iconRight={primaryIcon}
        title={primaryLabel}
        className={cn('px-4 w-full', buttonClasses, primaryClassName)}
        type={AtButtonTypes.PRIMARY}
        size={AtButtonDimensions.LARGE}
        isDisabled={primaryDisabled}
        onTrackClick={onTrackPrimaryClick}
        openUrl={primaryActionValue}
        target={primaryTarget}
        parentName={parentName}
      />
    )}
    {secondaryLabel && (
      <AtButton
        title={secondaryLabel}
        className={cn('px-4 w-full', buttonClasses, secondaryClassName)}
        typeButton={AtButtonBehaviors.BUTTON}
        type={AtButtonTypes.SECONDARY}
        size={AtButtonDimensions.LARGE}
        isDisabled={secondaryDisabled}
        onClick={onSecondaryClick}
        onTrackClick={onTrackSecondaryClick}
        openUrl={secondaryActionValue}
        target={secondaryTarget}
        parentName={parentName}
      />
    )}
  </div>
)
